export default {
  name: 'request-management',
  translationKey: 'request-management-module',
  routePrefix: 'request-management',
  routeNamePrefix: 'admin.request-management',
  directRoutesAvailable: false,
}
